import { Transition } from '@uirouter/core';
import { Action } from '../../common/actions/core/action';

export class OpenLoginDialogAction implements Action {
  constructor(public transition?: Transition) {}
}

export class CloseLoginDialogAction implements Action {}

export class McRequestedAction implements Action {
  constructor(public mcRequested: boolean) {}
}

export class OpenRegisterDialogAction implements Action {
  constructor(public territoryCode: string) {}
}

export class OpenFbLoginDialogAction implements Action {}

export class ResetLoginFormAction implements Action {}



// WEBPACK FOOTER //
// src/app/components/login-dialog/login-dialog.action.ts